import * as types from './constants';

export function updateLastGetNewMemberSuccess() {
  return {
    type: types.UPDATE_LAST_GET_NEW_MEMBER_SUCCESS,
  };
}

export function updateLastGetNewMemberError(error) {
  return {
    type: types.UPDATE_LAST_GET_NEW_MEMBER_ERROR,
    error,
  };
}

//* GET BRANDING INFO

/**
 * * get branding data success
 * ? payload is everything BE return
 * @param  {object} payload
 *
 */
export function getBrandingNoLoadingSuccess(payload) {
  return {
    type: types.GET_BRANDING_NO_LOADING_SUCCESS,
    payload,
  };
}

export function getBrandingNoLoadingFail(err) {
  return {
    type: types.GET_BRANDING_NO_LOADING_FAIL,
    err,
  };
}

export function updateLastGetNewProductSuccess() {
  return {
    type: types.UPDATE_LAST_GET_NEW_PRODUCT_SUCCESS,
  };
}
export function updateLastGetNewProductError(error) {
  return {
    type: types.UPDATE_LAST_GET_NEW_PRODUCT_ERROR,
    payload: error,
  };
}
